# Usage:
# <some-modal-directive amount-trap-focus>
#   <ul>
#     <li><a>Link 1</a></li>
#     <li><a>Link 2</a></li>
#     <li><a>Link 3</a></li>
#   </ul>
# </some-modal-directive>

# And for this example, in the modal-directive link function or controller add:
#   `$scope.$on("amountTrapFocus:close", () => $scope.methodUsedToCloseModal());`

angular.module("avant.customer_applications.directives").directive "amountTrapFocus", [
  "$rootScope", "$timeout",
  ($rootScope, $timeout) ->
    restrict: 'A'
    link: (scope, element) ->
      # Filter function to remove disabled elements from array
      scope.filter = (list, func) -> x for x in list when func(x)

      # Function used in filter to remove disabled and hidden elements
      scope.isVisibleAndEnabled = (el) ->
        !(el.disabled || scope.elOrAncestorHasDisplayNone(el))

      # Used to check whether links or any of their ancestors containers were hidden using CSS
      scope.elOrAncestorHasDisplayNone = (el) ->
        parent = el.parentElement
        return false if parent == null
        return (
          window.getComputedStyle(el).display == "none" ||
          scope.elOrAncestorHasDisplayNone(parent)
        )

      initialize = (invokingElement) ->
        # Remove any remnant listeners from previous invocations
        element.unbind "keydown"
        scope.$parent.elementInvokingModal = invokingElement || document.activeElement

        # # Initalize focusableElements var for use in "keydown" callback closure
        focusableElements = null

        # Timeout so that the element loads and other directives populate templates
        $timeout ->
          allFocusableElements = element.find('a, object, :input, iframe, [tabindex]')
          focusableElements = scope.filter allFocusableElements, scope.isVisibleAndEnabled
          firstFocusableElement = focusableElements?[0]
          firstFocusableElement?.focus()
        100

        element.on "keydown", (ev) ->
          TAB_KEY_CODE = 9
          ESC_KEY_CODE = 27

          # Close modal on Escape Keypress
          if (ev.key == 'Escape' || ev.keyCode == ESC_KEY_CODE)
            element.unbind "keydown"
            scope.$apply () ->
              $rootScope.$broadcast("amountTrapFocus:close")

          isTabPressed = (ev.key == 'Tab' || ev.keyCode == TAB_KEY_CODE)

          return if !isTabPressed || focusableElements.length == 0

          nonDisabledElements = scope.filter focusableElements, scope.isVisibleAndEnabled
          firstFocusableElement = nonDisabledElements[0]
          lastFocusableElement = nonDisabledElements[nonDisabledElements.length - 1]

          # Shift + Tab Keypress in first element in modal
          if ev.shiftKey && document.activeElement == firstFocusableElement
            lastFocusableElement.focus()
            ev.preventDefault()
          # Tab key press on last element in modal
          else if !ev.shiftKey && document.activeElement == lastFocusableElement
            firstFocusableElement.focus()
            ev.preventDefault()

      initialize()
      scope.$on "amountTrapFocus:reset", (_event, invoker) -> initialize(invoker)
]
